import React from 'react';
import FormDialog from 'scenes/Dialog/components/FormDialog';
import CandidateSetTagForm from 'scenes/Form/components/CandidateSetTagForm';
import BasicDialog from 'scenes/Dialog/components/BasicDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import CandidateStatusForm from 'scenes/Form/components/CandidateStatusForm';
import CandidateSetRatingForm from 'scenes/Form/components/CandidateSetRatingForm';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { Permission, Role } from 'helpers/user';
import { FileHelper } from 'helpers/file';
import { ENDPOINT } from 'constants/endpoints';
import { LinkBuilder } from 'helpers/link-builder';
import { post } from 'services/api';
import { POPUP_STYLES } from 'constants/popup-styles';

const withTakeActions = WrappedComponent => props => {
  const suppProps = { ...props };

  suppProps.takeAction = {
    resume: item => {
      post(
        ENDPOINT.ACTION.DOWNLOAD_RESUME + `/id/${item.CandidateID}`,
        { act: 'downloadResume', page: 0 },
        {},
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } } // for old logic
      ).then(response => {
        if (response.right === 0) {
          if (response.companyRight === 1) UpgradeRecruiterAccount();
          else {
            BasicDialog({
              bodyRender: 'You do not have permission to download resumes.',
              bodyStyles: POPUP_STYLES.warningBodyStyles,
              popupStyles: POPUP_STYLES.warningPopupStyles,
              popupInnerStyles: POPUP_STYLES.warningContentStyles,
            });
          }
          return;
        }

        if (response.exist === 0) {
          BasicDialog({
            bodyRender: 'This Candidate hasn`t uploaded a resume yet.',
            bodyStyles: POPUP_STYLES.warningBodyStyles,
            popupStyles: POPUP_STYLES.warningPopupStyles,
            popupInnerStyles: POPUP_STYLES.warningContentStyles,
          });
        } else {
          if (response.restricted === 1) {
            BasicDialog({
              bodyRender: (
                <div style={{ whiteSpace: 'pre-line', maxWidth: '500px' }}>
                  {response.message.replace(/<br\/>/gi, '\n')}
                </div>
              ),
            });
          } else {
            FileHelper.downloadInitByUrl(
              LinkBuilder.getCandidateResumeLink(item.CandidateID)
            );
          }
        }
      });
    },

    tag: item => {
      FormDialog({
        title: 'Tag Profile',
        popupStyles: POPUP_STYLES.formPopupStyles,
        popupInnerStyles: POPUP_STYLES.formInnerStyles,
        popupTitleStyles: POPUP_STYLES.formTitleStyles,
        compact: true,
        modeless: false,
        params: { item },
        form: (actions, params) => (
          <CandidateSetTagForm actions={actions} params={params} />
        ),
      }).then(
        () => BasicDialog({ bodyRender: 'Changes were successfully saved' }),
        response => ResponseErrorDialog({ response })
      );
    },

    status: (processId, candidate) => {
      return FormDialog({
        title: "Candidate's Status",
        compact: true,
        popupStyles: POPUP_STYLES.formPopupStyles,
        popupInnerStyles: POPUP_STYLES.formInnerStyles,
        popupTitleStyles: POPUP_STYLES.formTitleStyles,
        params: {
          processId,
          candidate,
        },
        form: (actions, params) => (
          <CandidateStatusForm actions={actions} params={params} />
        ),
      }).then(status => status, response => ResponseErrorDialog({ response }));
    },

    rate: (candidate, processId = null) => {
      if (Role.isRecruiterDefault(props.user)) {
        UpgradeRecruiterAccount();
        return Promise.reject();
      }

      return FormDialog({
        title: 'Rate Profile',
        modeless: false,
        popupStyles: POPUP_STYLES.formPopupStyles,
        popupInnerStyles: POPUP_STYLES.formInnerStyles,
        popupTitleStyles: POPUP_STYLES.formTitleStyles,
        compact: true,
        params: {
          candidate,
          processId,
          disableForm: !Permission.isAllowedRateCandidates(
            props.user.permissions
          ),
        },
        form: (actions, params) => (
          <CandidateSetRatingForm actions={actions} params={params} />
        ),
      }).then(null, response => ResponseErrorDialog({ response }));
    },
  };

  return <WrappedComponent {...suppProps} />;
};

export default withTakeActions;
